import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { Subject } from 'rxjs/Subject';
import { SessionhandlerService } from '../services/sessionhandler.service';
import { Config } from 'src/app/config/config';
import { CommonServiceLayerService, RequestPayLoadFormat } from '../services/common-service-layer.service';
import { AlertService } from '../shared/alert.service';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {
  constructor(
    public storage: SessionhandlerService,
    public alert: AlertService,
    public http: CommonServiceLayerService,
  ) { }
  private toggleModal = new BehaviorSubject<any>(false);
  private siteData = new BehaviorSubject<any>({});
  public staticFilter = {};
  public staticFilterFields = new BehaviorSubject<any>([]);
  public allFilters = new BehaviorSubject<any>({ fields: [], data: {} });
  public staticCalenderDFM = [
    {
      disabled: true,
      selectMode: 'range',
      placeholder: 'Time Range',
      name: 'Time Range',
      key: 'date',
      type: 'date',
      required: true,
      pickerType: 'both',
      columns: '8',
      identifier: 'dateRange'
    },
    {
      disabled: true,
      selectMode: 'range',
      placeholder: 'Time Range',
      name: 'Time Range',
      key: 'date',
      type: 'date',
      required: true,
      pickerType: 'calendar',
      columns: '4',
      identifier: 'calendarRange'
    },
    {
      disabled: true,
      selectMode: 'range',
      placeholder: 'Time Range',
      name: 'Time Range',
      key: 'date',
      type: 'date',
      required: true,
      pickerType: 'timer',
      columns: '4',
      identifier: 'timeRange'
    },
    {
      disabled: true,
      selectMode: 'single',
      placeholder: 'Time Range',
      name: 'Time Range',
      key: 'date',
      type: 'date',
      required: true,
      pickerType: 'both',
      columns: '4',
      identifier: 'singleDate'
    },
    {
      disabled: true,
      selectMode: 'single',
      placeholder: 'Date',
      name: 'Date',
      key: 'singleDate',
      type: 'date',
      required: true,
      pickerType: 'calendar',
      columns: '4',
      identifier: 'singleCalendar'
    },
    {
      disabled: true,
      selectMode: 'single',
      placeholder: 'Time Range',
      name: 'Time Range',
      key: 'date',
      type: 'date',
      required: true,
      pickerType: 'timer',
      columns: '4',
      identifier: 'singleTime'
    }
  ];
  public duplicates = {
    stations: {
      key: 'stations',
      placeholder: 'Stations',
      bindValue: 'key',
      name: 'Stations',
      required: true,
      bindLabel: 'label',
      type: 'multiselect',
      options: [],
      dependentOptions: {},
      multipleDependency: true,
      dependencyKeys: ['parameter', 'parameters']
    }
  };
  private alarmRefreshSubject = new Subject<any>();
  sendAlarmRefreshEvent() {
    this.alarmRefreshSubject.next();
  }
  getAlarmRefreshEvent(): Observable<any> {
    return this.alarmRefreshSubject.asObservable();
  }
  setToggleModal(flag) {
    if (!flag) {
      document.getElementById('filterModalCloseBtn').click();
    }
    this.toggleModal.next(flag);
  }
  getToggleModal(): Observable<any> {
    return this.toggleModal.asObservable();
  }
  setFiltersData(data) {
    this.storage.api.session.save('siteId', data.data.station || '');
    this.storage.api.session.save('siteName', data.data.selectedStation || '');
    this.allFilters.next(data);
  }
  getFiltersData() {
    return this.allFilters.asObservable();
  }
  setSiteData(data) {
    this.siteData.next(data);
  }
  getSiteData(): Observable<any> {
    return this.siteData.asObservable();
  }
  getSitesListDD(list) {
    const keys = Object.keys(list.siteName);
    const optionsList = [];
    keys.forEach(ele => {
      optionsList.push({ key: ele, label: list.siteName[ele] });
    });
    return optionsList;
  }

  // global filters code
  getAppliedStaticFilters() {
    return this.staticFilter;
  }
  setAppliedStaticFilters(data) {
    this.staticFilter = data;
  }
  // DFM JSON
  setStaticFilterFields(data) {
    this.staticFilterFields.next([...this.staticCalenderDFM, ...data]);
  }
  getStaticFilterFields(): Observable<any> {
    return this.staticFilterFields.asObservable();
  }

  fetchStaticFilters() {
    const payLoad = {
      loadType: ''
    };
    try {
      const request: RequestPayLoadFormat = {
        api: 'staticFilters',
        method: 'postText',
        loader: true,
        type: 'API',
        hideErrorMessage: false,
        payLoad
      };
      this.http.API_REQUEST(request).subscribe(response => {
        if (response.status) {
          this.stationsBinding(response.data.form);
        } else {
          this.alert.open('error', response.message, 'try again');
        }
      });
    } catch (error) {
      Config.logger(error);
    }
  }

  stationsBinding(data) {
    const multiselectDDs = ['station', 'monitoringType', 'monitoringStation'];
    // const multiselectFields = [];
    multiselectDDs.forEach(ddKey => {
      let fieldIndex;
      fieldIndex = data.findIndex(ele => ele.key === ddKey);
      if (fieldIndex > -1) {
        try {
          const dfmField = JSON.parse(JSON.stringify(this.duplicates[ddKey + 's']));
          dfmField.dependentOptions = data[fieldIndex].dependentOptions;
          dfmField.options = data[fieldIndex].options;
          data.splice(fieldIndex, 0, dfmField);
          // multiselectFields.push(dfmField);
        } catch (error) {
          console.log(error);
        }
      }
    });
    // data.splice(1, 0, ...multiselectFields);
    this.setStaticFilterFields(data);
  }
}
